import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);

/**
 * @param variant, variants 'violet50', 'magenta50', 'green50', 'shapeStatic', 'aquamarine',
 * 'gold', 'warning' are deprecated, shapeStatic doesn't exist no more,
 * transition is
 * green50 - accent07,
 * magenta50 - accent04,
 * violet50 - accent05,
 * shapeStatic - accent01,
 * gold - accent01,
 * warning - accent03,
 * aquamarine - accent06,
 */
export var Tag = /*#__PURE__*/memo(function (_ref) {
  var _cn;
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'accent05' : _ref$variant,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'white' : _ref$textColor,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 's' : _ref$size,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Tag' : _ref$testName,
    rightSideNode = _ref.rightSideNode,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('tag', "tag--".concat(size), "tag--".concat(variant), "tag--text-".concat(textColor), (_cn = {}, _defineProperty(_cn, className, !!className), _defineProperty(_cn, 'tag--black-border', variant === 'transparent' && textColor === 'black'), _defineProperty(_cn, 'tag--white-border', variant === 'transparent' && textColor === 'white'), _cn)),
    "data-component": testName
  }, children, size !== 'xs' && rightSideNode);
});
Tag.displayName = Tag.name;